import React, { cloneElement } from 'react'
import { Button, Col, Row, Form, Table, Label, Input, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup } from 'reactstrap'
import axios from 'axios'
import StorageService from '../services/StorageService'
import { MdDone, MdClear, MdCreate, MdSearch } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import CrmCustomerForm from '../components/CrmCustomerForm'
import PosProductForm from '../components/PosProductForm'
import SearchInput from '../components/SearchInput'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import { MDBDataTableV5 } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'

const tbcolumn = [
  {
    label: 'Category',
    field: 'category',
    sort: 'asc',
  },
  // {
  //   label: 'Membership ID',
  //   field: 'membership_id',
  //   sort: 'asc',
  // },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
  },
  // {
  //   label: 'Company',
  //   field: 'company',
  //   sort: 'asc',
  // },
  {
    label: 'Contact',
    field: 'contact',
    sort: 'asc',
  },
  {
    label: 'Address',
    field: 'billing_address',
    sort: 'asc',
  },
  {
    label: 'Postal Code',
    field: 'billing_postal_code',
    sort: 'asc',
  },
  {
    label: 'Unit',
    field: 'billing_unit',
    sort: 'asc',
  },
  {
    label: 'Contact Person',
    field: 'contact_person',
    sort: 'asc',
  },
  // {
  //   label: 'Email',
  //   field: 'email',
  //   sort: 'asc',
  // },
  {
    label: 'DND',
    field: 'DND',
    sort: 'asc',
  },
  // {
  //   label: 'Address',
  //   field: 'billing_address',
  //   sort: 'asc',
  // },
  // {
  //   label: 'Unit',
  //   field: 'billing_unit',
  //   sort: 'asc',
  // },
  // {
  //   label: 'Country',
  //   field: 'billing_country',
  //   sort: 'asc',
  // },
  // {
  //   label: 'Postal Code',
  //   field: 'billing_postal_code',
  //   sort: 'asc',
  // },
  // {
  //   label: 'Remarks',
  //   field: 'remarks',
  //   sort: 'asc',
  // },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

class CrmCustomerTable extends React.Component {
  _isMounted = true
  sortKey = sessionStorage.getItem('sortKey')
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      isGlobal: '',
      customerList: [],
      filterList: [],
      categoryList: [],
      redirect: false,
      selectedId: '',
      selectedData: '',
      searchKey: '',
      sortKey: this.sortKey ? this.sortKey : '',
    }
  }

  componentDidMount() {
    const user = StorageService.getSession('user_info')
    //if (user.superUser) {
    this.getCustomerList()
    this.getCategory()
    // } else {
    //   this.setState({
    //     redirect: true,
    //   });
    // }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getCustomerList()
    }
  }

  changeHandler = event => {
    const { name, value } = event.target
    this.setState({
      [name]: value,
    })
    if (name === 'sortKey') {
      sessionStorage.setItem('sortKey', value)
    }
  }

  // sortData() {
  //   const { customerList, sortKey } = this.state;
  //   if (sortKey.length) {
  //     customerList.sort((a, b) => a[sortKey] - b[sortKey]).reverse();
  //     console.log(customerList);
  //     this.setState({ customerList });
  //   } else {
  //     this.getCustomerList();
  //   }
  // }

  // searchChange = event => {
  //   const searchKey = event.target.value.toLowerCase();
  //   this.setState({ searchKey }, () => this.filteredList());
  // };

  // filteredList = () => {
  //   let customerList = this.state.customerList;
  //   let searchKey = this.state.searchKey;

  //   let customers = customerList.filter(customer => {
  //     return (
  //       customer.name.toLowerCase().indexOf(searchKey) != -1 ||
  //       customer.billing_address.toLowerCase().indexOf(searchKey) != -1 ||
  //       customer.billing_unit.toLowerCase().indexOf(searchKey) != -1 ||
  //       customer.billing_country.toLowerCase().indexOf(searchKey) != -1 ||
  //       customer.billing_postal_code.toLowerCase().indexOf(searchKey) != -1
  //     );
  //   });
  //   this.setState({ filteredList: customers });
  // };

  filterData() {
    const { customerList, sortKey } = this.state
    if (sortKey.length) {
      let item = customerList.filter(x => x.category === sortKey)
      this.setState({ filterList: item })
    } else {
      this.setState({ filterList: customerList })
    }
  }

  getCategory = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }
    axios
      .post(url + ':3004/v1/customer/category', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            categoryList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getCustomerList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }
    axios
      .post(url + ':3004/v1/customer', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (result.data.length > 0) {
          for (let i of result.data) {
            i.DND = <span className={'ps-indicator ' + (i.dnd == '1' ? 'on' : 'off')}>{i.dnd == '1' ? 'Yes' : 'No'}</span>

            i.Action = (
              <div className="ps-button-group">
                <Button className="theme-button theme-button-secondary" onClick={() => this.props.detail(i.customer_id)}>
                  View
                </Button>
              </div>
            )
          }
        }

        if (this._isMounted) {
          this.setState({
            customerList: result.data,
            filterList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  detail = id => {
    console.log(`/posstore/${this.props.data.store_id}/product` + id)
    this.props.history.push({
      pathname: `/posstore/${this.props.data.store_id}/product/` + id,
    })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    const data = {
      columns: tbcolumn,
      rows: this.state.filterList,
    }

    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <Row>
          <Col md={8}>
            <Row>
              <Label className="text-center" for="sortBy" sm={2}>
                Category
              </Label>

              <Col sm={4}>
                <Input className="ps-input-small" type="select" name="sortKey" value={this.state.sortKey} onChange={this.changeHandler}>
                  <option value="">Default</option>
                  {this.state.categoryList.map(item => {
                    return <option key={item.id}>{item.name}</option>
                  })}
                </Input>
              </Col>
              <Col sm={2}>
                <Button
                  className="theme-button theme-button-dark"
                  onClick={() => {
                    this.filterData()
                  }}>
                  Filter
                </Button>
              </Col>
            </Row>
          </Col>

          <Col md={4}>
            <div className="text-right mb-3">
              <div className="ps-btn-group">
                <Button color="link" onClick={this.toggle('ADD', null)}>
                  <IconContext.Provider value={{ color: '#2a2c6b' }}>
                    <BsPlusSquareFill size={25} />
                  </IconContext.Provider>
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <MDBDataTableV5 className="ps-customer-table" data={data} displayEntries={false} noRecordsFoundLabel="Click Add Button to add new Customer" searchTop searchBottom={false} fullPagination disableRetreatAfterSorting={true} responsive />

        <Modal
          isOpen={this.state.modal}
          // toggle={this.toggle()}
          className="modal-lg"
          centered>
          <CrmCustomerForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>
      </>
    )
  }
}
export default CrmCustomerTable
